(function () {
  'use strict';

  var STORAGE_KEY_LOGGED_IN = 'logged_in';
  var STORAGE_KEY_LAST_SAVED_HASH = 'cart-sync:last-saved-hash';
  var STORAGE_KEY_LAST_SAVED_AT = 'cart-sync:last-saved-at';
  var SAVE_API_URL = '/apps/cart-sync/api/cart/save';
  var STORAGE_KEY_RELOADED = 'cart-sync:reloaded';

  var syncing = false;
  // カート再構築後のフルリロードを1ナビゲーションにつき1回までに制限する(ループ防止)
  var reloadedThisNavigation = false;
  var feePhasePromise;
  var feeCartDirty = false;
  var saveFinalCart = false;
  var cartUIRefreshed = false;
  var domReady = document.readyState === 'complete';
  document.addEventListener('DOMContentLoaded', function () { domReady = true; }, { once: true });

  function isCartPage() {
    return window.themeVariables && window.themeVariables.settings.pageType === 'cart';
  }

  function saveBeforeRefresh(cart) {
    if (isCartPage()) {
      saveFinalCart = true;
      return Promise.resolve();
    }
    return postSave(cart);
  }

  function runFeePhase() {
    if (!isCartPage()) return Promise.resolve({ changed: false });
    if (feePhasePromise) return feePhasePromise;
    var feeScriptsReady = domReady || document.readyState === 'complete' || window.CartFeeSync
      ? Promise.resolve()
      : new Promise(function (resolve) {
          document.addEventListener('DOMContentLoaded', resolve, { once: true });
        });
    feePhasePromise = feeScriptsReady.then(function () {
      var wasSyncing = syncing;
      syncing = true;
      return Promise.resolve().then(function () {
        return feeCartDirty ? fetchCartJson() : undefined;
      }).then(function (cart) {
        if (!window.CartFeeSync) return { changed: false, cart: cart };
        return window.CartFeeSync.reconcile(cart);
      }).catch(function (error) {
        console.error('[cart-sync] fee phase failed:', error);
        return { changed: false };
      }).then(function (result) {
        if (!result.changed && !saveFinalCart) return result;
        var finalCart = result.cart && (result.changed || feeCartDirty)
          ? Promise.resolve(result.cart)
          : fetchCartJson();
        return finalCart.then(function (cart) {
          if (!isLoggedIn()) {
            setLastSavedAt(new Date().toISOString());
            return;
          }
          return postSave(cart);
        }).then(function () { return result; });
      }).finally(function () {
        syncing = wasSyncing;
      });
    });
    return feePhasePromise;
  }

  // ---- storage helpers ----

  function isLoggedIn() {
    try { return localStorage.getItem(STORAGE_KEY_LOGGED_IN) === 'true'; }
    catch (e) { return false; }
  }

  function setLoggedIn(value) {
    try { localStorage.setItem(STORAGE_KEY_LOGGED_IN, value ? 'true' : 'false'); }
    catch (e) {}
  }

  function getLastSavedHash() {
    try { return localStorage.getItem(STORAGE_KEY_LAST_SAVED_HASH) || ''; }
    catch (e) { return ''; }
  }

  function setLastSavedHash(hash) {
    try { localStorage.setItem(STORAGE_KEY_LAST_SAVED_HASH, hash); }
    catch (e) {}
  }

  function removeLastSavedHash() {
    try { localStorage.removeItem(STORAGE_KEY_LAST_SAVED_HASH); }
    catch (e) {}
  }

  function getLastSavedAt() {
    try { return localStorage.getItem(STORAGE_KEY_LAST_SAVED_AT) || '1970-01-01T00:00:00Z'; }
    catch (e) { return '1970-01-01T00:00:00Z'; }
  }

  function setLastSavedAt(at) {
    try { localStorage.setItem(STORAGE_KEY_LAST_SAVED_AT, at); }
    catch (e) {}
  }

  function parseTimestamp(value) {
    var timestamp = new Date(value || '1970-01-01T00:00:00Z').getTime();
    return isNaN(timestamp) ? 0 : timestamp;
  }

  // ---- cart helpers ----

  function readSavedCart() {
    var raw = window.cartSyncData && window.cartSyncData.savedCart;
    if (!raw) return null;
    if (typeof raw === 'string') {
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }
    return raw;
  }

  function setNormalizedProperty(target, key, value) {
    if (key === undefined || key === null || key === '') return;
    target[String(key)] = value === undefined || value === null ? '' : value;
  }

  function normalizeProperties(properties) {
    var normalized = {};
    if (!properties) return normalized;

    if (Array.isArray(properties)) {
      properties.forEach(function (property) {
        if (!property) return;
        if (Array.isArray(property)) {
          setNormalizedProperty(normalized, property[0], property[1]);
          return;
        }
        if (typeof property === 'object') {
          var key = property.name;
          if (key === undefined) key = property.key;
          if (key === undefined) key = property.first;
          if (key === undefined) key = property[0];

          var value = property.value;
          if (value === undefined) value = property.last;
          if (value === undefined) value = property[1];
          setNormalizedProperty(normalized, key, value);
        }
      });
      return normalized;
    }

    if (typeof properties !== 'object') return normalized;

    Object.keys(properties).forEach(function (key) {
      setNormalizedProperty(normalized, key, properties[key]);
    });
    return normalized;
  }

  function normalize(item) {
    var sellingPlan = item.selling_plan;
    if (sellingPlan === undefined || sellingPlan === null) {
      sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation.selling_plan.id
        : null;
    }
    var props = normalizeProperties(item.properties);
    return {
      variant_id: item.variant_id,
      quantity: item.quantity,
      properties: props,
      selling_plan: sellingPlan
    };
  }

  function canonicalSellingPlan(sellingPlan) {
    return sellingPlan === undefined || sellingPlan === null || sellingPlan === '' ? '' : String(sellingPlan);
  }

  function canonicalProperties(properties) {
    var normalized = normalizeProperties(properties);
    return Object.keys(normalized).sort().reduce(function (ordered, key) {
      ordered[key] = String(normalized[key]);
      return ordered;
    }, {});
  }

  function canonicalQuantity(quantity) {
    var value = Number(quantity);
    return isNaN(value) ? 0 : value;
  }

  function canonicalLineItem(item) {
    var normalized = normalize(item || {});
    return {
      variant_id: normalized.variant_id === undefined || normalized.variant_id === null ? '' : String(normalized.variant_id),
      quantity: canonicalQuantity(normalized.quantity),
      properties: canonicalProperties(normalized.properties),
      selling_plan: canonicalSellingPlan(normalized.selling_plan)
    };
  }

  function lineItemKey(item) {
    var canonical = canonicalLineItem(item);
    return canonical.variant_id + '::' + canonical.selling_plan + '::' + JSON.stringify(canonical.properties);
  }

  function canonicalCartItems(cart) {
    var itemMap = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var canonical = canonicalLineItem(item);
      var key = lineItemKey(canonical);
      if (!itemMap[key]) {
        itemMap[key] = {
          key: key,
          variant_id: canonical.variant_id,
          quantity: 0,
          properties: canonical.properties,
          selling_plan: canonical.selling_plan
        };
      }
      itemMap[key].quantity += canonical.quantity;
    });
    return Object.keys(itemMap).sort().map(function (key) {
      return itemMap[key];
    });
  }

  function canonicalCartSignature(cart) {
    return {
      items: canonicalCartItems(cart),
      note: cart && cart.note !== undefined && cart.note !== null ? String(cart.note) : ''
    };
  }

  function cartItemsHash(cart) {
    return JSON.stringify(canonicalCartItems(cart));
  }

  function cartHash(cart) {
    if (!cart) return '';
    return JSON.stringify(canonicalCartSignature(cart));
  }

  function isEqualCart(a, b) {
    return cartHash(a) === cartHash(b);
  }

  function isEqualCartItems(a, b) {
    return cartItemsHash(a) === cartItemsHash(b);
  }

  // ---- merge ----

  function mergeCarts(localCart, serverCart) {
    var localLastSavedAt = getLastSavedAt();
    var serverUpdatedAt = (serverCart && serverCart.updated_at) || '1970-01-01T00:00:00Z';
    var serverIsNewer = new Date(serverUpdatedAt).getTime() >= new Date(localLastSavedAt).getTime();

    var map = new Map();
    var first = serverIsNewer ? localCart : serverCart;
    var second = serverIsNewer ? serverCart : localCart;

    (first && first.items ? first.items : []).forEach(function (item) {
      var n = normalize(item);
      map.set(lineItemKey(n), n);
    });
    (second && second.items ? second.items : []).forEach(function (item) {
      var n = normalize(item);
      var key = lineItemKey(n);
      if (map.has(key)) {
        map.set(key, Object.assign({}, map.get(key), { quantity: n.quantity }));
      } else {
        map.set(key, n);
      }
    });

    var merged = {
      items: Array.from(map.values()),
      note: (serverIsNewer ? (serverCart && serverCart.note) : (localCart && localCart.note)) || '',
      attributes: (serverIsNewer ? (serverCart && serverCart.attributes) : (localCart && localCart.attributes)) || {}
    };
    return merged;
  }

  // ---- API ----

  function toAddPayload(item) {
    var payload = {
      id: item.variant_id,
      quantity: item.quantity
    };
    if (item.properties && Object.keys(item.properties).length > 0) {
      payload.properties = item.properties;
    }
    if (item.selling_plan) {
      payload.selling_plan = item.selling_plan;
    }
    return payload;
  }

  function postSave(cart) {
    var normalizedItems = (cart.items || []).map(normalize);
    var body = {
      items: normalizedItems,
      note: cart.note || ''
    };
    return fetch(SAVE_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (response.ok) {
        return response.json().then(function (result) {
          setLastSavedAt((result && result.updated_at) || new Date().toISOString());
          setLastSavedHash(cartHash({ items: normalizedItems, note: cart.note || '' }));
          return { ok: true, result: result };
        });
      }
      if (response.status >= 400 && response.status < 500) {
        console.error('[cart-sync] save failed (client error):', response.status);
        setLastSavedHash(cartHash({ items: normalizedItems, note: cart.note || '' }));
        return { ok: false, status: response.status };
      }
      console.error('[cart-sync] save failed (server error):', response.status);
      return { ok: false, status: response.status };
    }).catch(function (e) {
      console.error('[cart-sync] save failed:', e);
      return { ok: false, error: e };
    });
  }

  function fetchCartJson() {
    return fetch('/cart.js', { cache: 'reload' }).then(function (r) {
      return r.json();
    });
  }

  function clearLocalCart() {
    return fetch('/cart/clear.js', { method: 'POST' });
  }

  function addLineItem(item) {
    var payload = { items: [toAddPayload(item)] };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        var err = new Error('Failed to add item');
        err.status = response.status;
        throw err;
      }
      return response.json();
    });
  }

  function updateCartMeta(note, attributes) {
    var body = {};
    if (note !== undefined) body.note = note || '';
    if (attributes) body.attributes = attributes;
    if (Object.keys(body).length === 0) {
      return Promise.resolve(null);
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
  }

  // ---- restore (clear + re-add) ----

  // ヘッダーのカートアイコンをローディング表示に切り替える(再構築中の視覚フィードバック)
  function setCartIconLoading(isLoading) {
    var icons = document.querySelectorAll('.header__icon-wrapper--cart .header__icon');
    for (var i = 0; i < icons.length; i++) {
      icons[i].classList.toggle('cart-icon--syncing', !!isLoading);
    }
  }

  function restoreLocalCart(targetCart) {
    var failed = [];
    feeCartDirty = true;
    saveFinalCart = true;
    syncing = true;
    setCartIconLoading(true);
    return clearLocalCart().then(function () {
      var items = targetCart.items || [];
      return items.reduce(function (chain, item) {
        return chain.then(function () {
          return addLineItem(item).catch(function (e) {
            console.warn('[cart-sync] item add failed (likely out of stock):', item, e);
            failed.push(item);
          });
        });
      }, Promise.resolve());
    }).then(function () {
      return updateCartMeta(targetCart.note, targetCart.attributes);
    }).then(function () {
      syncing = false;
      return { failed: failed };
    }).catch(function (e) {
      syncing = false;
      setCartIconLoading(false);
      throw e;
    });
  }

  // ---- UI refresh ----

  function refreshMainCartSection() {
    var wrapper = document.querySelector('[data-cart-sync-main-cart]');
    var sectionWrapper = wrapper && wrapper.closest ? wrapper.closest('[id^="shopify-section-"]') : null;
    sectionWrapper = sectionWrapper || (wrapper && wrapper.id && wrapper.id.indexOf('shopify-section-') === 0 ? wrapper : null);
    if (!sectionWrapper) {
      console.warn('[cart-sync] main-cart section wrapper not found; skipping partial refresh');
      return Promise.resolve();
    }
    var sectionId = sectionWrapper.id.replace('shopify-section-', '');
    return fetch('/cart?section_id=' + encodeURIComponent(sectionId))
      .then(function (response) {
        if (!response.ok) throw new Error('Section fetch failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        sectionWrapper.outerHTML = html;
      });
  }

  function refreshUI(options) {
    return runFeePhase().then(function (result) {
      if (result.changed && isCartPage()) options = { reloadOnCartPage: true };
      return refreshUIAfterFees(options);
    });
  }

  function refreshUIAfterFees(options) {
    options = options || {};
    var pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;
    if (pageType === 'cart') cartUIRefreshed = true;
    // カート再構築後にカートページを表示している場合は、部分更新ではなくフルリロードする
    // (差分が収束しないケースでのリロードループを防ぐため1ナビゲーションにつき1回まで)
    if (options.reloadOnCartPage && pageType === 'cart' && !reloadedThisNavigation) {
      reloadedThisNavigation = true;
      try { sessionStorage.setItem(STORAGE_KEY_RELOADED, '1'); } catch (e) {}
      window.location.reload();
      return Promise.resolve();
    }
    return fetchCartJson().then(function (cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cart }
      }));
      var sectionPromise = (pageType === 'cart')
        ? refreshMainCartSection().catch(function (e) {
            console.error('[cart-sync] main-cart section refresh failed:', e);
          })
        : Promise.resolve();
      return sectionPromise.then(function () {
        // cart-sync 由来の refresh を示すフラグを立てる(下記インターセプタで判別)
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cart, fromCartSync: true }
        }));
        // UI 更新が終わったのでローディング表示を解除
        // (カートページのリロード経路では上で return 済みのため、ここは到達しない=リロードまで表示継続)
        setCartIconLoading(false);
      });
    });
  }

  function showNotification(status, message) {
    document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
      bubbles: true,
      detail: { status: status, error: message }
    }));
  }

  // ---- state detection ----

  function detectTransition() {
    var wasLoggedIn = isLoggedIn();
    var isCustomerPresent = !!(window.cartSyncData && window.cartSyncData.customer);
    var transition;
    if (!wasLoggedIn && isCustomerPresent) transition = 'LOGIN';
    else if (wasLoggedIn && !isCustomerPresent) transition = 'LOGOUT';
    else if (isCustomerPresent) transition = 'LOGGED_IN_CONTINUE';
    else transition = 'LOGGED_OUT_CONTINUE';
    return transition;
  }

  // ---- flows ----

  function mergeFlow() {
    var localCart = (window.cartSyncData && window.cartSyncData.cart) || { items: [], note: '', attributes: {} };
    var serverCart = readSavedCart() || { items: [], note: '', attributes: {}, updated_at: '1970-01-01T00:00:00Z' };
    var merged = mergeCarts(localCart, serverCart);
    var localEqualsMerged = isEqualCart(localCart, merged);

    // ローカルとマージ結果が同じなら復元処理スキップ
    if (localEqualsMerged) {
      return saveBeforeRefresh(merged).then(function () {
        setLoggedIn(true);
        return refreshUI();
      });
    }

    return restoreLocalCart(merged).then(function (res) {
      var failed = res.failed;
      var finalItems = (merged.items || []).filter(function (item) {
        var key = lineItemKey(normalize(item));
        return !failed.some(function (f) { return lineItemKey(normalize(f)) === key; });
      });
      var finalCart = { items: finalItems, note: merged.note, attributes: merged.attributes };
      return saveBeforeRefresh(finalCart).then(function () {
        setLoggedIn(true);
        return refreshUI({ reloadOnCartPage: true }).then(function () {
          if (failed.length > 0) {
            showNotification('error', '在庫切れのため一部商品をスキップしました（' + failed.length + '件）');
          }
        });
      });
    });
  }

  function syncCheckFlow() {
    var localCart = (window.cartSyncData && window.cartSyncData.cart) || { items: [] };
    var serverCart = readSavedCart();
    if (!serverCart) {
      return Promise.resolve();
    }

    // 在庫都合でローカルカートが調整された場合 (cart-sync-data.liquid が検知) は
    // 以降の早期 return を素通りさせ、既存のカート再構築パスに合流させる
    // (在庫切れ商品の除去と通知は restoreLocalCart の失敗ハンドリングで行われる)
    var inventoryAdjusted = !!(window.cartSyncData && window.cartSyncData.inventoryAdjusted);

    if (!inventoryAdjusted && isEqualCartItems(localCart, serverCart)) {
      return Promise.resolve();
    }

    var localMatchesLastSave = cartHash(localCart) === getLastSavedHash();
    var serverUpdatedAt = parseTimestamp(serverCart.updated_at);
    var lastSavedAt = parseTimestamp(getLastSavedAt());
    var serverIsNewerThanLastSave = serverUpdatedAt > lastSavedAt;

    if (!inventoryAdjusted && localMatchesLastSave && !serverIsNewerThanLastSave) {
      return Promise.resolve();
    }

    if (!inventoryAdjusted && !serverIsNewerThanLastSave) {
      return saveBeforeRefresh(localCart);
    }

    var target = {
      items: serverCart.items || [],
      note: serverCart.note || '',
      attributes: serverCart.attributes || {}
    };

    return restoreLocalCart(target).then(function (res) {
      var failed = res.failed;
      var notifyPromise = Promise.resolve();
      if (failed.length > 0) {
        var finalItems = (target.items || []).filter(function (item) {
          var key = lineItemKey(normalize(item));
          return !failed.some(function (f) { return lineItemKey(normalize(f)) === key; });
        });
        notifyPromise = saveBeforeRefresh({ items: finalItems, note: target.note, attributes: target.attributes }).then(function () {
          showNotification('error', '在庫切れのため一部商品をスキップしました（' + failed.length + '件）');
        });
      }
      return notifyPromise.then(function () { return refreshUI({ reloadOnCartPage: true }); });
    });
  }

  function saveFlow(cart) {
    if (!cart) {
      return Promise.resolve();
    }
    var hash = cartHash(cart);
    if (hash === getLastSavedHash()) {
      return Promise.resolve();
    }
    return postSave(cart);
  }

  function clearFlow() {
    syncing = true;
    feeCartDirty = true;
    return clearLocalCart().then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to clear cart: ' + response.status);
      }
      removeLastSavedHash();
      setLoggedIn(false);
      return refreshUI();
    }).then(function () {
      syncing = false;
    }).catch(function (e) {
      syncing = false;
      console.error('[cart-sync] clear flow failed:', e);
    });
  }

  // ---- cart:refresh interceptor ----

  // pageshow など外部から発火される cart:refresh をインターセプトし、
  // savedCart と最新ローカルカートに差分が無ければ cart-drawer の再描画を阻止する
  function interceptCartRefresh(event) {
    if (event.detail && event.detail.fromCartSync) {
      return;
    }
    if (event.detail && event.detail.openCustomMiniCart) {
      return;
    }
    if (syncing) {
      return;
    }
    if (!isLoggedIn()) {
      return;
    }
    var serverCart = readSavedCart();
    var cart = event.detail && event.detail.cart;
    if (!serverCart || !cart || !Array.isArray(cart.items)) {
      return;
    }
    if (isEqualCart(cart, serverCart)) {
      event.stopImmediatePropagation();
    }
  }

  // ---- init ----

  function init() {
    // 直前のカート再構築でフルリロードした直後かどうかを記録し、フラグはクリアする
    // (リロード後の再診断で差分が残っても二重リロードしないようにするため)
    try {
      reloadedThisNavigation = sessionStorage.getItem(STORAGE_KEY_RELOADED) === '1';
      sessionStorage.removeItem(STORAGE_KEY_RELOADED);
    } catch (e) {}
    var transition = detectTransition();
    var flowPromise;
    if (transition === 'LOGIN') {
      flowPromise = mergeFlow();
    } else if (transition === 'LOGOUT') {
      flowPromise = clearFlow();
    } else if (transition === 'LOGGED_IN_CONTINUE') {
      flowPromise = syncCheckFlow();
    } else {
      flowPromise = Promise.resolve();
    }

    window.CartSync.ready = flowPromise.then(function () {
      return runFeePhase();
    }).then(function (result) {
      if (result.changed && !cartUIRefreshed) return refreshUI({ reloadOnCartPage: true });
    }).catch(function (e) {
      console.error('[cart-sync] init flow failed:', e);
      setCartIconLoading(false);
    });

    // capture phase で listen して、差分なしの cart:refresh を他のリスナー (cart-drawer 等) より先に阻止する
    document.documentElement.addEventListener('cart:refresh', interceptCartRefresh, true);
  }

  // ---- public API ----
  function touchLocalCartUpdatedAt() {
    if (syncing) {
      return;
    }
    setLastSavedAt(new Date().toISOString());
  }

  // theme.js の各カート変更箇所から cart:updated 発火前に呼ばれる
  function save(cart) {
    if (!isLoggedIn()) {
      touchLocalCartUpdatedAt();
      return Promise.resolve();
    }
    if (syncing) {
      return Promise.resolve();
    }
    return saveFlow(cart);
  }

  // theme.js を経由しない直接 fetch から呼ばれる (ラッピング処理用)
  // 現在の /cart.js を取得して即時 save する
  function saveImmediate() {
    if (!isLoggedIn()) {
      touchLocalCartUpdatedAt();
      return Promise.resolve();
    }
    return fetchCartJson().then(function (cart) { return saveFlow(cart); });
  }

  window.CartSync = {
    save: save,
    saveImmediate: saveImmediate,
    _internal: {
      mergeCarts: mergeCarts,
      cartHash: cartHash,
      cartItemsHash: cartItemsHash,
      isEqualCart: isEqualCart,
      isEqualCartItems: isEqualCartItems,
      normalize: normalize,
      detectTransition: detectTransition
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
